import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { isEmpty } from 'lodash'
import Fuse from 'fuse.js'

import Loader from 'components/Loader'
import Layout from 'components/Layout'
import RolesPermissionsFilters from 'views/RolesPermissions/Filters'
import RolesPermissionsLayout from 'views/RolesPermissions/Layout'

import paginationCoordinator from 'utils/general/paginationCoordinator'
import { extendFuseOptions } from 'utils/search/extendFuseOptions'
import { useGetRolesQuery } from 'store/porticoApi/roles'
import { TRoleWithPermissions } from 'types/roles'

const RolesPermissions = () => {
  const [searchQuery, setSearchQuery] = useState('')

  const { data: roles, isFetching } = useGetRolesQuery()

  const location = useLocation()
  const navigate = useNavigate()

  const fuseKeys = ['name']

  // we have to omit roles in which name include 'superadmin'
  const rolesWithoutSuperAdmin = roles?.filter(
    (role) => !role.name.toLowerCase().includes('superadmin')
  )

  // roles should be alphabetically sorted
  const alphabeticallySortedRoles =
    rolesWithoutSuperAdmin?.slice().sort((a, b) => a?.name.localeCompare(b?.name)) ?? []

  const fuse = new Fuse(alphabeticallySortedRoles ?? [], extendFuseOptions(fuseKeys))

  const filteredRoles = isEmpty(searchQuery)
    ? alphabeticallySortedRoles
    : fuse.search(searchQuery)?.map((role) => role.item)

  const paginator = paginationCoordinator<TRoleWithPermissions>(filteredRoles, location, navigate)
  const rolesFilteredAndPaginatedResult = paginator?.result

  if (isFetching) {
    return <Loader />
  }

  return (
    <Layout
      mainContent={
        <RolesPermissionsLayout roles={rolesFilteredAndPaginatedResult} paginator={paginator} />
      }
      navbarContent={
        <RolesPermissionsFilters searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      }
    />
  )
}

export default RolesPermissions
